/**
 * @generated SignedSource<<764353e669154b575ddf3e6d6a6334e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type MultiSlotAgendaQuery$variables = {
  courseIds: ReadonlyArray<string>;
  date: string;
  facilityId: string;
  requestConfigs: boolean;
};
export type MultiSlotAgendaQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly id: string;
    readonly slug?: string;
    readonly type?: FacilityType;
    readonly " $fragmentSpreads": FragmentRefs<"BidirectionalStickyScroller_facilities">;
  } | null | undefined;
};
export type MultiSlotAgendaQuery = {
  response: MultiSlotAgendaQuery$data;
  variables: MultiSlotAgendaQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requestConfigs"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "kind": "Variable",
  "name": "dateGte",
  "variableName": "date"
},
v11 = {
  "kind": "Variable",
  "name": "dateLte",
  "variableName": "date"
},
v12 = {
  "kind": "Variable",
  "name": "courseIds",
  "variableName": "courseIds"
},
v13 = [
  (v5/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPublic",
  "storageKey": null
},
v15 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v17 = [
  (v6/*: any*/),
  (v5/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMins",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Agenda",
  "kind": "LinkedField",
  "name": "agenda",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeSlotConnection",
  "kind": "LinkedField",
  "name": "bufferSlots",
  "plural": false,
  "selections": [
    (v18/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v24 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MultiSlotAgendaQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BidirectionalStickyScroller_facilities"
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "MultiSlotAgendaQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityCopyOverrides",
                "kind": "LinkedField",
                "name": "copyOverrides",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NounOverride",
                    "kind": "LinkedField",
                    "name": "course",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "plural",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              (v12/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1000
                              }
                            ],
                            "concreteType": "TimeSlotConnection",
                            "kind": "LinkedField",
                            "name": "timeSlots",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstDateTime",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastDateTime",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "QueueSlot",
                            "kind": "LinkedField",
                            "name": "queueSlot",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v12/*: any*/)
                ],
                "concreteType": "CourseConnection",
                "kind": "LinkedField",
                "name": "courses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Course",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Facility",
                            "kind": "LinkedField",
                            "name": "facility",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Club",
                                "kind": "LinkedField",
                                "name": "club",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "supportsPrivate",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PublicBookingPermissionSet",
                                "kind": "LinkedField",
                                "name": "publicBookingPermissionSet",
                                "plural": false,
                                "selections": (v15/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PrivateBookingPermissionSet",
                                "kind": "LinkedField",
                                "name": "privateBookingPermissionSet",
                                "plural": false,
                                "selections": (v15/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v10/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10000
                              }
                            ],
                            "concreteType": "TimeSlotConnection",
                            "kind": "LinkedField",
                            "name": "timeSlots",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TimeSlotEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeSlot",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "availability",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasSplitBooking",
                                        "storageKey": null
                                      },
                                      (v16/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BookingConnection",
                                        "kind": "LinkedField",
                                        "name": "bookings",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BookingEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v6/*: any*/),
                                                  {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isBooking"
                                                  },
                                                  (v5/*: any*/),
                                                  (v9/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "canUpdate",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "writeAccess",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "RoundConnection",
                                                    "kind": "LinkedField",
                                                    "name": "rounds",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "RoundEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v5/*: any*/),
                                                              (v6/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": null,
                                                                "kind": "LinkedField",
                                                                "name": "player",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v6/*: any*/),
                                                                  (v5/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "firstName",
                                                                    "storageKey": null
                                                                  },
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "lastName",
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "startSlot",
                                                    "plural": false,
                                                    "selections": (v17/*: any*/),
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SlotConnection",
                                                    "kind": "LinkedField",
                                                    "name": "slots",
                                                    "plural": false,
                                                    "selections": [
                                                      (v18/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "SlotEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          (v19/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v20/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "startSlot",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v16/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": [
                                                                  {
                                                                    "kind": "Literal",
                                                                    "name": "bookingType",
                                                                    "value": "STANDARD"
                                                                  }
                                                                ],
                                                                "kind": "ScalarField",
                                                                "name": "capacity",
                                                                "storageKey": "capacity(bookingType:\"STANDARD\")"
                                                              },
                                                              (v21/*: any*/)
                                                            ],
                                                            "type": "TimeSlot",
                                                            "abstractKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v22/*: any*/)
                                                    ],
                                                    "type": "StandardBooking",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v20/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "startSlot",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v16/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": [
                                                                  {
                                                                    "kind": "Literal",
                                                                    "name": "bookingType",
                                                                    "value": "LESSON"
                                                                  }
                                                                ],
                                                                "kind": "ScalarField",
                                                                "name": "capacity",
                                                                "storageKey": "capacity(bookingType:\"LESSON\")"
                                                              },
                                                              (v21/*: any*/)
                                                            ],
                                                            "type": "TimeSlot",
                                                            "abstractKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v22/*: any*/)
                                                    ],
                                                    "type": "LessonBooking",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimeSlotBlock",
                                        "kind": "LinkedField",
                                        "name": "block",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BlockSeries",
                                            "kind": "LinkedField",
                                            "name": "blockSeries",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isVisibleToMembers",
                                                "storageKey": null
                                              },
                                              (v5/*: any*/),
                                              (v9/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "color",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startAt",
                                            "storageKey": null
                                          },
                                          (v20/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSlot",
                                        "kind": "LinkedField",
                                        "name": "eventSlot",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v5/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventSession",
                                            "kind": "LinkedField",
                                            "name": "eventSession",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "bufferMinsAfter",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "bufferMinsBefore",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": "bookingRestrictions",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "bookingType",
                                            "value": [
                                              "STANDARD"
                                            ]
                                          },
                                          {
                                            "kind": "Literal",
                                            "name": "isBlocking",
                                            "value": true
                                          },
                                          {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": [
                                              "RESTRICTION"
                                            ]
                                          }
                                        ],
                                        "concreteType": "SlotBookingRulesConnection",
                                        "kind": "LinkedField",
                                        "name": "bookingRules",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SlotBookingRulesEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              (v23/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v6/*: any*/),
                                                  (v5/*: any*/),
                                                  (v9/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": "visibility",
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "memberVisibility",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "BookingRestrictionRule",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "bookingRules(bookingType:[\"STANDARD\"],isBlocking:true,type:[\"RESTRICTION\"])"
                                      },
                                      {
                                        "condition": "requestConfigs",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          {
                                            "alias": "requestRestrictions",
                                            "args": (v24/*: any*/),
                                            "concreteType": "SlotBookingRulesConnection",
                                            "kind": "LinkedField",
                                            "name": "bookingRules",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "SlotBookingRulesEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  (v23/*: any*/),
                                                  (v19/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "bookingRules(type:[\"REQUEST\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "requestConfigs",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "alias": "configuredRequestRestrictions",
                                            "args": (v24/*: any*/),
                                            "concreteType": "SlotBookingRulesConnection",
                                            "kind": "LinkedField",
                                            "name": "requestWindowBookingRules",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "SlotBookingRulesEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  (v23/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "requestOpens",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "requestCloses",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v5/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "memberVisibility",
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "RequestConfig",
                                                            "kind": "LinkedField",
                                                            "name": "requestConfig",
                                                            "plural": false,
                                                            "selections": (v13/*: any*/),
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "type": "RequestRule",
                                                        "abstractKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4685bae8c593118a19523f63e072b5e9",
    "id": null,
    "metadata": {},
    "name": "MultiSlotAgendaQuery",
    "operationKind": "query",
    "text": "query MultiSlotAgendaQuery(\n  $facilityId: ID!\n  $date: Date!\n  $courseIds: [ID!]!\n  $requestConfigs: Boolean!\n) {\n  node(id: $facilityId) {\n    id\n    __typename\n    ... on Facility {\n      id\n      slug\n      type\n      ...BidirectionalStickyScroller_facilities\n    }\n  }\n}\n\nfragment BidirectionalStickyScroller_facilities on Facility {\n  id\n  name\n  copyOverrides {\n    course {\n      plural\n    }\n  }\n  ...useGetFirstLastTimeAcrossCoursesPatron_facilities\n  ...ColumnHeaderRow_facilities\n  ...CourseColumns_facilities\n  courses(courseIds: $courseIds) {\n    count\n    edges {\n      node {\n        id\n        ...SingleCourseColumn_course\n      }\n    }\n  }\n  agendas(dateGte: $date, dateLte: $date) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment BlockSlot_block on TimeSlotBlock {\n  id\n  startAt\n  durationMins\n  blockSeries {\n    name\n    color\n    id\n  }\n}\n\nfragment BookingSlot_booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  name\n  ... on StandardBooking {\n    durationMins\n    startSlot {\n      __typename\n      ... on TimeSlot {\n        time\n        capacity(bookingType: STANDARD)\n        agenda {\n          facility {\n            club {\n              supportsPublic\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n      id\n    }\n  }\n  ... on LessonBooking {\n    durationMins\n    startSlot {\n      __typename\n      ... on TimeSlot {\n        time\n        capacity(bookingType: LESSON)\n        agenda {\n          facility {\n            club {\n              supportsPublic\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n      id\n    }\n  }\n  canUpdate\n  writeAccess\n  rounds {\n    edges {\n      node {\n        id\n        __typename\n        player {\n          __typename\n          id\n          firstName\n          lastName\n        }\n      }\n    }\n  }\n}\n\nfragment ColumnHeaderRow_facilities on Facility {\n  id\n  name\n  courses(courseIds: $courseIds) {\n    edges {\n      node {\n        id\n        ...ColumnHeader_course\n      }\n    }\n  }\n}\n\nfragment ColumnHeader_course on Course {\n  id\n  name\n}\n\nfragment CourseColumns_facilities on Facility {\n  id\n  name\n  ...useGetFirstLastTimeAcrossCoursesPatron_facilities\n  courses(courseIds: $courseIds) {\n    count\n    edges {\n      node {\n        id\n        name\n        ...SingleCourseColumn_course\n      }\n    }\n  }\n  agendas(dateGte: $date, dateLte: $date) {\n    edges {\n      node {\n        id\n        queueSlot {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment EventSlot_eventSession on EventSession {\n  id\n}\n\nfragment SingleCourseColumn_course on Course {\n  id\n  name\n  facility {\n    id\n    ...getFacilityMemberPermissions_facility\n    club {\n      supportsPublic\n      id\n    }\n  }\n  timeSlots(first: 10000, dateGte: $date, dateLte: $date) {\n    edges {\n      node {\n        id\n        availability\n        hasSplitBooking\n        time\n        dateTime\n        bookings {\n          edges {\n            node {\n              __typename\n              ...BookingSlot_booking\n              id\n              startSlot {\n                __typename\n                id\n              }\n              slots {\n                count\n                edges {\n                  node {\n                    __typename\n                    id\n                  }\n                }\n              }\n              ... on StandardBooking {\n                bufferSlots {\n                  count\n                }\n              }\n              ... on LessonBooking {\n                bufferSlots {\n                  count\n                }\n              }\n            }\n          }\n        }\n        block {\n          id\n          blockSeries {\n            isVisibleToMembers\n            id\n          }\n          ...BlockSlot_block\n        }\n        eventSlot {\n          type\n          id\n          eventSession {\n            id\n            bufferMinsAfter\n            bufferMinsBefore\n            ...EventSlot_eventSession\n          }\n        }\n        bookingRestrictions: bookingRules(type: [RESTRICTION], isBlocking: true, bookingType: [STANDARD]) {\n          edges {\n            liftAt\n            node {\n              __typename\n              id\n              name\n              ... on BookingRestrictionRule {\n                visibility: memberVisibility\n              }\n            }\n          }\n        }\n        requestRestrictions: bookingRules(type: [REQUEST]) @skip(if: $requestConfigs) {\n          edges {\n            liftAt\n            node {\n              __typename\n              id\n            }\n          }\n        }\n        configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) @include(if: $requestConfigs) {\n          edges {\n            liftAt\n            requestOpens\n            requestCloses\n            node {\n              __typename\n              id\n              ... on RequestRule {\n                memberVisibility\n                requestConfig {\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment useGetFirstLastTimeAcrossCoursesPatron_facilities on Facility {\n  id\n  type\n  agendas(dateGte: $date, dateLte: $date) {\n    edges {\n      node {\n        id\n        timeSlots(first: 1000, courseIds: $courseIds) {\n          firstDateTime\n          lastDateTime\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ef9bbb2ec09dbe87300e104680103c1";

export default node;
